// extracted by mini-css-extract-plugin
export var cardLayout = "_8p-1";
export var paginationContainer = "_8p-0";